import _ from 'lodash';
import { createSelector } from 'reselect';
import { getConfigLoading } from 'containers/MusicPage/selectors/config';
import { getSessionLoading } from 'containers/MusicPage/selectors/session';
import { getPlaylistsError } from 'containers/MusicPage/selectors/playlists';

export const getPlaylistState = state => _.get(state, 'musicPlaylist');

export const getPlaylistModel = createSelector(
  [getPlaylistState],
  playlistState => _.get(playlistState, 'model'),
);

export const getPlaylistLoading = createSelector(
  [getPlaylistState],
  playlistState => _.get(playlistState, 'loading'),
);

export const getPlaylistTrackTable = createSelector(
  [getPlaylistModel],
  model => _.get(model, ['TRACKS_TABLE']),
);

export const getPlaylistTableBody = createSelector(
  [getPlaylistTrackTable],
  tracksTable =>
    _.flow(
      obj => _.get(obj, 'items'),
      col =>
        _.map(col, item =>
          _.map(_.get(item, 'properties'), head => ({
            ...head,
            trimed_text: _.truncate(head.text, { length: 24 }),
          })),
        ), // [{ head1: {..}}]
    )(tracksTable),
);

export const getPlayListTableHeader = createSelector(
  [getPlaylistTrackTable],
  tracksTable => _.get(tracksTable, 'properties'),
);

export const getTracksTableData = createSelector(
  [getPlayListTableHeader, getPlaylistTableBody],
  (header, body) => ({ header, body }),
);

export const getPlaylistLoadingPage = createSelector(
  [getConfigLoading, getSessionLoading, getPlaylistLoading],
  (configLoading, sessionLoading, playlistLoading) =>
    _.some([configLoading, sessionLoading, playlistLoading]),
);

export const getPlaylistButtons = createSelector(
  [getPlaylistModel],
  model => _.get(model, ['BOTONERA', 'items']),
);

export const getPlaylistArtwork = createSelector(
  [getPlaylistButtons],
  buttons =>
    _.flow(
      obj => _.find(obj, { type: 'IMAGE' }),
      obj => _.get(obj, ['properties', 'source']),
    )(buttons),
);

export const getPlaylistButton = createSelector(
  [getPlaylistButtons],
  buttons =>
    _.flow(
      obj => _.find(obj, { type: 'BUTTON_PLAY' }),
      obj => _.get(obj, ['properties']),
    )(buttons),
);

export const getPlaylistMeta = createSelector(
  [getPlaylistButtons],
  buttons =>
    _.flow(
      obj => _.filter(obj, { type: 'TEXT' }),
      col => _.map(col, obj => _.get(obj, ['properties'])),
      col =>
        _.filter(
          col,
          ({ text }) =>
            !text.includes('seguidores') && !text.includes('Seguidores'),
        ),
    )(buttons),
);

export const getPlaylistInfo = createSelector(
  [getPlaylistMeta, getPlaylistArtwork, getPlaylistButton],
  (meta, artwork, button) => ({ meta, artwork, button }),
);

export const getPlaylistHeader = createSelector(
  [getPlaylistModel],
  model => _.get(model, ['HEADER', 'properties']),
);

export const getPlaylistDetailError = createSelector(
  [getPlaylistState],
  playlistState => _.get(playlistState, ['error']),
);

export const getDetailError = createSelector(
  [getPlaylistsError, getPlaylistDetailError],
  (playlistError, detailError) => _.some([playlistError, detailError]),
);
